const END_POINT = '/parent-categories'

import BasicCrudAPI from './basicCrud.api.js'

const ParentCategoryAPI = new BasicCrudAPI(END_POINT)

export default ParentCategoryAPI
